"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _globals = require("~/utils/globals");
async function _default({ ncMeta }) {
    const actions = [];
    const hooks = await ncMeta.knexConnection(_globals.MetaTable.HOOKS);
    for (const hook of hooks){
        actions.push(ncMeta.metaUpdate(hook.fk_workspace_id, hook.base_id, _globals.MetaTable.HOOKS, {
            version: 'v1'
        }, hook.id));
    }
    await Promise.all(actions);
}
